import { HttpClient } from './httpClient'
import { HttpPostRequest } from './setFormData.js'

const deleteEvent = "DELETE_ENTRY_SUMMARY_ENTITY"

export const deleteDuty = (invoiceId ,merchandiseId, merchandiseDutyId, pscShipId) => {
  let dataSent = {
    eventType: deleteEvent,
    eventTime: Date.now(),
    eventMessage: {
      shipmentId: pscShipId || window.shipmentId,
      descriptionOfMerchandise: {
        entrySummaryInvoices:[{
          invoiceId,
          merchandiseLineItems: [
            {
              shipmentId: pscShipId || window.shipmentId,
              merchandiseId: merchandiseId,
              merchandiseDuties: [
                {
                  merchandiseDutyId: merchandiseDutyId
                }
              ]
            }
          ]
        }]
    
      }
    }
  }
  return HttpPostRequest(dataSent)
    .catch(error => {
      console.error(`Error from axios on FIELD delete: `, error)
    })
}

export const deleteMerchandise = (invoiceId ,merchandiseId, merchIndex, updateStatus, articleSetId, pscShipId) => {
  //debugger;
  let dataSent = {
    eventType: deleteEvent,
    eventTime: Date.now(),
    eventMessage: {
      shipmentId: pscShipId || window.shipmentId,
      descriptionOfMerchandise: {
        entrySummaryInvoices : [{
          invoiceId,
          merchandiseLineItems: [
            {
              merchandiseId: merchandiseId,
              articleSetId: articleSetId,
              shipmentId: pscShipId || window.shipmentId,
            }
          ]

        }]
   
      }
    }
  }
  return HttpPostRequest(dataSent)///
    .catch(error => {
      console.error(`Error from axios on FIELD delete: `, error)
    })
}

export const deleteInvoice = (invoiceId) => {
  let dataSent = {
    eventType: deleteEvent,
    eventTime: Date.now(),
    eventMessage: {
      shipmentId: window.shipmentId,
      descriptionOfMerchandise: {
        "entrySummaryInvoices": [
          {
            shipmentId: window.shipmentId,
            invoiceId
          }
      ]
      }
    }
  }
  return HttpPostRequest(dataSent)///
    .catch(error => {
      console.error(`Error from axios on FIELD delete: `, error)
    })
}


export const deleteUserFee = (merchandiseId, merchandiseDutyId, userFee, userFeeStillExists,invoiceddId, shipmentId) => {
  let dataSent = {
    eventType: deleteEvent,
    eventTime: Date.now(),
    eventMessage: {
      shipmentId: shipmentId,
        descriptionOfMerchandise: {
          entrySummaryInvoices :[{
            invoiceId: invoiceddId,
            merchandiseLineItems: [
              {
                merchandiseId: merchandiseId,
                merchandiseDuties: [
                  {
                    merchandiseDutyId: merchandiseDutyId,
                    isCommodityDuty: 1,
                    additionalDuties: {
                      userFees: [
                        {
                          dutyType: userFee,
                          disclaim: "1"
                        }
                      ]
                    }
                  }
                ]
              }
            ]
        }]
      }
    }
  }
  // if the user fee no longer exists, delete it from totals as well
  if (!userFeeStillExists) {
    dataSent.eventMessage.additionalDuties = {
      userFees: [
        {
          dutyType: userFee
        }
      ]
    }
  }
  return HttpPostRequest(dataSent)
    .catch(error => {
      console.error(`Error deleting userFee`, error)
    })
}

export const deleteContainer = number => {
  let dataSent = {
    eventType: deleteEvent,
    eventTime: Date.now(),
    eventMessage: {
      bolInfo: {
        container: [
          {
            number: number
          }
        ]
      }
    }
  }
  HttpPostRequest(dataSent)
    .catch(error => {
      console.error(`Error from axios on FIELD delete: `, error)
    })
}

export const deletePGAItems = (pgaGuid, pgaItems, merchandiseId, formType = 1) => {
  if (!pgaItems || !pgaItems.length) {//warning, whole form will be deleted if we don't do this
    return new Promise((resolve, reject) => {
      resolve({});
    });
  }
  let dataSent = {
    eventType: deleteEvent,
    eventTime: Date.now(),
    eventMessage: {
      shipmentId: window.shipmentId,
      merchandiseId,
      pgaGuids:[(pgaGuid+"").indexOf("FAKEGUID_")>=0?null:pgaGuid],
      formType,
      pgaItems
    }
  }
  window.lastSaveXDDD = Date.now();
  return HttpPostRequest(dataSent)
    .catch(error => {
      console.error(`Error DELETE_ENTRY_SUMMARY ENTITY`, error)
    })
}

export const deletePgaFormData = (pgasFlagsToDelete, merchandiseId, shipmentId) => {
  if(!pgasFlagsToDelete || !pgasFlagsToDelete.length){
    console.log("NOTHING TO DELEEEETE!",pgasFlagsToDelete, merchandiseId, shipmentId)
    return;
  }
  let dataSent = {
    eventMessage: {
      shipmentId: shipmentId,
      merchandiseId: merchandiseId,
      "formType": pgasFlagsToDelete.map(a=>a.pgaType),
      "pgaGuids": pgasFlagsToDelete.map(a=>(a.pgaGuid+"").indexOf("FAKEGUID_")>=0?null:a.pgaGuid)
    },
    eventType: deleteEvent,
    eventTime: Date.now()
  }
  return HttpPostRequest(dataSent)
    .catch(error => {
      console.error(`Error DELETE_ENTRY_SUMMARY ENTITY`, error)
    })
}

export const deleteAdCvdFormData = (merchandiseId, merchandiseDutyId, shipmentId, invoiceId) => {
  let dataSent = {
    eventMessage: {
      shipmentId: shipmentId,
      descriptionOfMerchandise: {
        entrySummaryInvoices :[{
          invoiceId,
          merchandiseLineItems: [{
            merchandiseId: merchandiseId,
              merchandiseDuties: [
                {
                  "merchandiseDutyId": merchandiseDutyId,
                  "adcvd": {
                      "ad": {
                        "caseNo": "_DELETE_"
                      },
                      "cvd": {
                        "caseNo": "_DELETE_"
                      }
                  }
                }
              ]
            }]
          }]
        } 
    },
    eventType: deleteEvent,
    eventTime: Date.now()
  }
  HttpPostRequest(dataSent)
    .catch(error => {
      console.error(`Error DELETE_ENTRY_SUMMARY ENTITY`, error)
    })
}

export const deleteNotesItem = (noteId) => {
  let dataSent = {
      eventType: "DELETE_SHIPMENT_NOTES",
      eventTime: Date.now(),
      eventMessage: 
              {
                  shipmentId: window.shipmentId,
                  noteId
              }
          
      
      };

  return HttpClient.post(dataSent)
      .catch(error => {
          console.error(`Error from axios on FIELD delete: `, error)
      })

}
